import { P2GBox } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import SidePanelSection from '../../../../../components/sidepanel-section';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

interface props {
  affected: number;
  confirm?: () => void;
  cancel?: () => void;
}

export default function DownloadLabels(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <P2GBox>
      <P2GBox mt={2}>
        <SidePanelSection title={t('COMING_SOON', { defaultValue: 'Coming soon...' })}>
          <P2GText>
            <Trans
              t={t}
              i18nKey="COMING_SOON_MESSAGE"
              values={{ affected: props.affected }}
              defaults="This feature is coming soon. You'll be able to select your {{affected}} Smart Send orders and download a PDF with all of these labels combined and ready to print."
            />
          </P2GText>
        </SidePanelSection>

        <P2GBox mt={2}>
          <P2GGrid container spacing={2}>
            {props.confirm && (
              <P2GGrid item>
                <P2GButton onClick={props.confirm}>{t('SAVE_BUTTON', { defaultValue: 'Save' })}</P2GButton>
              </P2GGrid>
            )}
            {props.cancel && (
              <P2GGrid item>
                <P2GButton variant="primary" onClick={props.cancel}>
                  {t('BACK_BUTTON', { defaultValue: 'Back' })}
                </P2GButton>
              </P2GGrid>
            )}
          </P2GGrid>
        </P2GBox>
      </P2GBox>
    </P2GBox>
  );
}
